import React from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import { HiOutlineMail } from "react-icons/hi";
import { BsLinkedin, BsGithub, BsArrowRight, BsPatchCheck } from "react-icons/bs";
import { colors, font, pagePx } from "../theme/tokens";
import SectionHeading from "../components/SectionHeading";
import Reveal from "../components/Reveal";

const certs = [
  {
    name: "Full Stack Open — University of Helsinki",
    detail: "Modern web development with React, Node.js, and TypeScript.",
    url: "https://studies.cs.helsinki.fi/stats/api/certificate/fullstackopen/en/cae3b87824dd5fb8cd482546c9b23c2b",
  },
  {
    name: "Full Stack Open — GraphQL",
    detail: "GraphQL APIs, Apollo Client & Server.",
    url: "https://studies.cs.helsinki.fi/stats/api/certificate/fs-graphql/en/1bb9559b2cf7489a910a7bc223247e1d",
  },
];

const Contact = () => {
  return (
    <Box component="section" id="contact" sx={{ px: pagePx, py: { xs: 8, md: 12 }, position: "relative", overflow: "hidden" }}>
      <Box className="aurora" sx={{ width: 400, height: 400, background: "#4f46e5", bottom: -160, left: "30%", opacity: 0.3 }} />

      {/* Certifications strip */}
      <Reveal>
        <Box sx={{ maxWidth: 900, mx: "auto", mb: { xs: 7, md: 9 } }}>
          <Typography sx={{ textAlign: "center", fontFamily: font.mono, fontSize: 13, fontWeight: 600, letterSpacing: "3px", textTransform: "uppercase", color: colors.accent, mb: 3 }}>
            Certifications
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ justifyContent: "center" }}>
            {certs.map((c) => (
              <Box
                key={c.name} component="a" href={c.url} target="_blank" rel="noopener noreferrer"
                sx={{
                  flex: 1, p: 2.5, borderRadius: "14px", backgroundColor: colors.surface, border: `1px solid ${colors.border}`,
                  display: "flex", gap: 1.5, alignItems: "flex-start", transition: "all 0.2s ease",
                  "&:hover": { borderColor: colors.accent, transform: "translateY(-3px)" },
                }}
              >
                <BsPatchCheck style={{ color: colors.green, fontSize: 22, flexShrink: 0, marginTop: 2 }} />
                <Box>
                  <Typography sx={{ fontSize: 14.5, fontWeight: 600, color: colors.ink }}>{c.name}</Typography>
                  <Typography sx={{ fontSize: 13, color: colors.inkSoft }}>{c.detail}</Typography>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      </Reveal>

      {/* Contact CTA */}
      <Reveal>
        <Box sx={{ position: "relative", zIndex: 1, textAlign: "center", maxWidth: 720, mx: "auto" }}>
          <SectionHeading eyebrow="Contact" title="Let's build something solid together" />
          <Typography sx={{ fontSize: 16, color: colors.inkSoft, lineHeight: 1.75, mb: 4 }}>
            I'm actively looking for <Box component="span" sx={{ color: colors.ink, fontWeight: 600 }}>software
            engineering opportunities</Box> — full-time, internship, or contract — remote or with relocation.
            If you're hiring or want to talk architecture, my inbox is open.
          </Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ justifyContent: "center", mb: 4 }}>
            <Button
              endIcon={<BsArrowRight />}
              href="mailto:hamdaniibrahim.contact@gmail.com"
              startIcon={<HiOutlineMail />}
              sx={{
                background: colors.gradPrimary, color: "#0b1120", fontFamily: font.sans, fontWeight: 700,
                fontSize: 15, textTransform: "none", px: 3.5, py: 1.4, borderRadius: "12px",
                boxShadow: "0 8px 30px rgba(99,102,241,0.35)",
                "&:hover": { transform: "translateY(-2px)" }, transition: "all 0.2s ease",
              }}
            >
              hamdaniibrahim.contact@gmail.com
            </Button>
          </Stack>

          <Stack direction="row" spacing={3} sx={{ justifyContent: "center" }}>
            <a href="https://www.linkedin.com/in/ibrahimn9/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <BsLinkedin className="icon" style={{ fontSize: 28 }} />
            </a>
            <a href="https://github.com/ibrahimn9" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <BsGithub className="icon" style={{ fontSize: 28 }} />
            </a>
          </Stack>
        </Box>
      </Reveal>
    </Box>
  );
};

export default Contact;
